import { useState, useEffect } from "react";
import { Card, Col, Container } from "react-bootstrap";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import axios from 'axios'
import { FormikSelect } from '../../../components/FormikSelect';
import { FormikInput } from '../../../components/FormikInput';
import { CrudButton } from "../../../components/CrudButton";
import { getOrquestadorApiUrl } from "../../../../_metronic/helpers/ApiOrquestadorHelper";
import { ActionModal } from "../../../components/ActionModal";
import moment from "moment";
import { AtencionesWebFormReasignar } from "./AtencionesWebFormReasignar";
import { getParametroApiUrl } from "../../../../_metronic/helpers/ApiParametroHelpers";
import { AtencionesWebFormSeguimiento } from "./AtencionesWebFormSeguimiento";
import { AtencionesWebFormOtrosCasos } from "./AtencionesWebFormOtrosCasos";
import { AtencionesWebFormAnexos } from "./AtencionesWebFormAnexos";
import React from "react";
import DataTable, { TableColumn, ExpanderComponentProps } from 'react-data-table-component';
import { NoRecords, PaginationProperties, customStyles, MAX_TEXT_LENGTH } from "../../../components/DataTableConfig";
import { PdfBase64 } from "../../../components/PdfBase64";
import { InputFilter } from "../../../components/Input";
import { getAdministradorApiUrl } from "../../../../_metronic/helpers/ApiAdministradorHelpers";
import { CustomExpanderGeneric } from "src/app/utilities";
import { getOrientacionEInformacionApiUrl } from "src/_metronic/helpers/ApiOrientacionEInformacionHelpers";
import Swal from "sweetalert2";
import { BandejaAtencionesWebContextInterface } from "src/app/models";
import { useSelector } from "react-redux";
import { SiCuentanosStore } from "src/app/redux/store";

const currentDate = moment();

export const bandejaWebContext = React.createContext<BandejaAtencionesWebContextInterface | null>(null);

const BandejaWebSchema = Yup.object().shape({
    DtFechaInicio: Yup.date()
        .required('Campo obligatorio')
        .max(currentDate, 'La fecha no puede ser mayor a la fecha actual'),        
    DtFechaFin: Yup.date()
        .required('Campo obligatorio')
        .test('valida_fecha', 'Fecha fin no puede ser menor a fecha inicio', function (dtFechaFin: any) {
            const refDtFechaInicio: string = this.resolve(Yup.ref('DtFechaInicio'));
            var momentA = moment(dtFechaFin, "DD/MM/YYYY");
            var momentB = moment(refDtFechaInicio, "DD/MM/YYYY");
            if (momentA < momentB) {
                return false;
            }
            return true;
        }),
    EstadoId: Yup.number()
        .min(0, 'Campo obligatorio'),
    VcCorreo: Yup.string().email("Correo no válido"),
    UsuarioId: Yup.number()
        .min(0, "Campo obligatorio")
});

export function BandejaAtencionesWeb(props: any) {
    const userDto = useSelector((state:SiCuentanosStore)=> state.user); 
    const [UsuarioLogueado] = useState<any>((userDto.vcPrimerNombre || '') + ' ' + (userDto.vcSegundoNombre || '') + ' ' + (userDto.vcPrimerApellido || '') + ' ' + (userDto.vcSegundoApellido || ''));
    const [modo, setModo] = useState('');
    const [AtencionWebId, setAtencionWebId] = useState([]);
    const [PersonaWebId, setPersonaWebId] = useState([]);
    const [payload, setPayload] = useState({
        DtFechaInicio: moment().add(-1, 'M').format('YYYY-MM-DD'),
        DtFechaFin: moment().format('YYYY-MM-DD'),
        EstadoId: 0,
        VcCorreo: '',
        UsuarioId: props.modo === '1' ? userDto.id : 0
    });
    const [dataEstados, setDataEstados] = useState<any>([]);
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [dataSourceFilter, setDataSourceFilter] = useState([]);
    const [modalReAsignar, setModalReAsignar] = useState(false);
    const [modalSeguimiento, setModalSeguimiento] = useState(false);
    const [modalOtrosCasos, setModalOtrosCasos] = useState(false);
    const [modalAnexos, setModalAnexos] = useState(false);
    const [dataSourcePdf, setDataSourcePdf] = useState(null);
    const [modalVisiblePdf, setModalVisiblePdf] = useState(false);
    const [dataSourceOtrosCasos, setDataSourceOtrosCasos] = useState([]);
    const [dataSourceSeguimiento, setDataSourceSeguimiento] = useState([]);
    const [dataSourceFilterSeguimiento, setDataSourceFilterSeguimiento] = useState([]);
    const [valueFilter, setValueFilter] = useState('');

    const obtenerBandeja = async (payload:any) => {
        setDataSource([]);
        setDataSourceFilter([]);
        setValueFilter('');
        const datos = { ...payload };
        datos.DtFechaFin = moment(datos.DtFechaFin).format('YYYY-MM-DD[T23:59:59]');
        await axios.post(getOrquestadorApiUrl('AtencionWeb/bandeja'), datos)
            .then((response) => {
                // Obtenemos los datos
                const data = response.data.models ?? [];
                setDataSource(data);
                setDataSourceFilter(data);
            })
            .catch(e => {
                // Capturamos los errores
                console.log(e.response);
            });
    }

    const obtenerDatosUsuarios = async () => {
        await axios.get(getAdministradorApiUrl('Usuario'))
            .then((response) => {
                // Obtenemos los datos
                const dataArray: any = [];
                const data: any = response.data.models || [];

                dataArray.push({ value: 0, label: 'TODOS' });
                data.forEach((element: any) => {
                    dataArray.push({ value: element.id, label: element.vcPrimerNombre + ' ' + element.vcPrimerApellido });
                });
                setDataUsuarios(dataArray);
            })
            .catch(e => {
                // Capturamos los errores
                console.log(e);
            });
    }

    const obtenerDataParametroDetalle = async (codigo: any, setData: any) => {
        await axios.get(getParametroApiUrl(`ParametroDetalle/porCodigoInterno/${codigo}`))
            .then((response) => {
                // Obtenemos los datos
                const dataArray: any = [];
                if (codigo === 'bEstadoCaso') {
                    dataArray.push({ value: 0, label: 'TODOS', codigo: '' });
                }
                const data = response.data.models ? response.data.models : [];
                data.forEach((element: any) => {
                    dataArray.push({ value: element.id, label: element.vcNombre, codigo: element.vcCodigoInterno });
                });
                setData(dataArray);
            })
            .catch(e => {
                // Capturamos los errores
                console.log(e);
            });
    }

    useEffect(() => {
        setModo(props.modo);
        setPayload({
            DtFechaInicio: moment().add(-1, 'M').format('YYYY-MM-DD'),
            DtFechaFin: moment().format('YYYY-MM-DD'),
            EstadoId: 0,
            VcCorreo: '',
            UsuarioId: props.modo === '1' ? userDto.id : 0
        });
    }, [props.modo]);

    useEffect(() => {
        obtenerDataParametroDetalle('bEstadoCaso', setDataEstados);
        obtenerBandeja(payload);
        if (modo === '2') {
            obtenerDatosUsuarios();
        }
    }, [modo]);

    const reAsignar = (element: any) => {
        setAtencionWebId(element.id);
        setModalReAsignar(true);
    }
    const seguimiento = (element: any) => {
        setAtencionWebId(element.id);
        setModalSeguimiento(true);
    }
    const otrosCasos = (element: any) => {
        setPersonaWebId(element.personaWebId);
        setAtencionWebId(element.id);
        setModalOtrosCasos(true);
    }
    const verAnexos = (element: any) => {
        setPersonaWebId(element.personaWebId);
        setAtencionWebId(element.id);
        setModalAnexos(true);
    }

    const imprimirCaso = async (atencionGrupalId: number) => {
        await axios.get(getOrquestadorApiUrl(`AtencionWeb/pdf/${atencionGrupalId}`))
            .then((response) => {
                // Obtenemos los datos
                setDataSourcePdf(response.data.pdf ?? null);
                setModalVisiblePdf(true);
                //setModalVisible(true);
            })
            .catch(e => {
                // Capturamos los errores
                console.log(e.response);
            });
    }

   
    const obtenerDatosSeguimiento = async () => {
        setDataSourceSeguimiento([]);
        setDataSourceFilterSeguimiento([]);
        setValueFilter('');
        await axios.get(getOrquestadorApiUrl(`AtencionWebSeguimiento/porAtencionWebId/${AtencionWebId}`))
            .then((response) => {
                // Obtenemos los datos
                const data = response.data?.models || [];
                setDataSourceSeguimiento(data);
                setDataSourceFilterSeguimiento(data);
            })
            .catch(e => {
                // Capturamos los errores
                console.log(e);
            });
    }

    const crearSeguimiento = async (data: any) => {
        const bCierraCaso = data.BCierraCaso;
        const codEstado = bCierraCaso ? 'CER' : 'SEG';
        try {
            data.estadoId = dataEstados.filter((item: any) => item.codigo === codEstado)[0].value;
            await axios.post(getOrientacionEInformacionApiUrl(`AtencionWebSeguimiento/crear/`), data)
                .then((response) => {
                    const data = response.data;
                    mostrarMensaje(data.titulo, data.mensaje, '1', bCierraCaso);
                    obtenerDatosSeguimiento();
                })
                .catch(e => {
                    // Capturamos los errores
                    const data = e?.response?.data;
                    if (data?.codigo === 400) {
                        mostrarMensaje(data.titulo, data.mensaje, '4', false);
                    }
                });            
        } catch (error) {
            console.log(error);
            Swal.fire({
                title: '¡Algo salió Mal!',
                text: 'No está configurado los códigos CER y SEG para los estados del caso en el módulo administrador',
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            }).then((result: any) => {

            });              
        }

    }

    const mostrarMensaje = (titulo: string, mensaje: string, icon: string, bCierraCaso: any) => {
        Swal.fire({
            title: titulo,
            text: mensaje,
            icon: icon == '1' ? 'success' : icon === '2' ? 'info' : icon === '3' ? 'warning' : 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        }).then((result: any) => {
            if (result.isConfirmed) {
                if (bCierraCaso == true) {
                    setModalSeguimiento(false);
                    obtenerBandeja(payload);
                }
            }
        })
    }    

    const datosBandejaWebContext: BandejaAtencionesWebContextInterface = {
        UsuarioId: userDto.id,
        UsuarioLogueado: '',
        AtencionWebId: AtencionWebId,
        PersonaWebId: PersonaWebId,
        dataEstados: dataEstados,
        dataSource: dataSource,
        setDataSource: setDataEstados,
        modalReAsignar: modalReAsignar,
        setModalReAsignar: setModalReAsignar,
        modalSeguimiento: modalSeguimiento,
        setModalSeguimiento: setModalSeguimiento,
        modalOtrosCasos: modalOtrosCasos,
        setModalOtrosCasos: setModalOtrosCasos,
        modalAnexos: modalAnexos,
        setModalAnexos: setModalAnexos,
        modalVisiblePdf: modalVisiblePdf,
        dataSourcePdf: dataSourcePdf,
        setModalVisiblePdf: setModalVisiblePdf,
        dataSourceOtrosCasos: dataSourceOtrosCasos,
        obtenerDatosSeguimiento:obtenerDatosSeguimiento,
        crearSeguimiento:crearSeguimiento,
        mostrarMensaje:mostrarMensaje,
        dataSourceSeguimiento: dataSourceSeguimiento,
        dataSourceFilterSeguimiento: dataSourceFilterSeguimiento,
        setDataSourceFilterSeguimiento:setDataSourceFilterSeguimiento
    }

    interface DataRow {
        id: number;
        acciones: string;
        iAnexos: string;
        dtFechaOrientacion: string;
        estado: string,
        vcCorreo: string;
        diasSinRespuesta: any;
        tipoGestion: string;
        tipoProcesoFallido: string;
        vcNombreCompleto: string;
        tipoSolicitud: string;
        motivo: string;
        subMotivo: string;
        txAclaracionMotivo: string;
        dtFechaRegistro: string;
        usuario: string;
        usuarioActual: string;
        txAsuntoCorreo: string;
    }

    const columns: TableColumn<DataRow>[] = [
        {
            name: 'Id del caso',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Acciones',
            cell: (element) =>
                <div>
                    <CrudButton className="btn-icon btn-sm btn-danger" icon="bi bi-printer" onClick={() => imprimirCaso(element.id)} toolTip="imprimir caso" />
                    {element.estado?.toLowerCase() !== 'cerrado' ?
                        <div>
                            <CrudButton className="btn-icon btn-sm btn-success mt-1" icon="bi bi-person" onClick={() => reAsignar(element)} toolTip="Asignar caso" />
                            <CrudButton className="btn-icon btn-sm btn-primary mt-1" icon="bi bi-search" onClick={() => seguimiento(element)} toolTip="Registrar seguimiento al caso" />
                        </div>
                        : null}
                    <CrudButton className="btn-icon btn-sm btn-primaryCustom mt-1" icon="bi bi-bootstrap-reboot" onClick={() => otrosCasos(element)} toolTip="Ver otros casos de la persona" />
                </div>,
            sortable: false,
        },
        {
            name: 'Anexos',
            cell: (element) => <CrudButton className="btn-icon btn-sm btn-primary" text={element.iAnexos} onClick={() => verAnexos(element)} toolTip="Ver anexos del caso" />,
            sortable: false,
        },
        {
            name: 'Fecha de orientación',
            cell: (element) => <p>{moment(element.dtFechaOrientacion).format('YYYY-MM-DD')}</p>,
            selector: row => row.dtFechaOrientacion,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Estado del caso',
            cell: (element) => <p>{element.estado}</p>,
            selector: row => row.estado,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Correo',
            cell: (element) => <p>{element.vcCorreo}</p>,
            selector: row => row.vcCorreo,
            sortable: true,
            minWidth: '220px'
        },
        {
            name: 'Días sin respuesta',
            cell: (element) => <span className="badge" style={{ backgroundColor: element.diasSinRespuesta.color }}>{element.diasSinRespuesta.dias}</span>,
            selector: row => row.diasSinRespuesta.dias,
            sortable: true,
            center: true,
            minWidth: '150px'
        },
        {
            name: 'Tipo Gestión',
            cell: (element) => <p>{element.tipoGestion}</p>,
            selector: row => row.tipoGestion,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Tipo proceso fallido',
            cell: (element) => <p>{element.tipoProcesoFallido}</p>,
            selector: row => row.tipoProcesoFallido,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Nombres y Apellidos',
            cell: (element) => <p>{element.vcNombreCompleto}</p>,
            selector: row => row.vcNombreCompleto,
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'Tipo de solicitud',
            cell: (element) => <p>{element.tipoSolicitud}</p>,
            selector: row => row.tipoSolicitud,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Motivo',
            cell: (element) => <p>{element.motivo}</p>,
            selector: row => row.motivo,
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'Sub motivo',
            cell: (element) => <p>{element.subMotivo}</p>,
            selector: row => row.subMotivo,
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'Aclaraciones',
            cell: (element) => <p>{element.txAclaracionMotivo.length > MAX_TEXT_LENGTH ? `${element.txAclaracionMotivo.slice(0, MAX_TEXT_LENGTH)}...` : element.txAclaracionMotivo}</p>,
            sortable: false,
            minWidth: '250px'
        },
        {
            name: 'Asunto',
            cell: (element) => <p>{element.txAsuntoCorreo.length > MAX_TEXT_LENGTH ? `${element.txAsuntoCorreo.slice(0, MAX_TEXT_LENGTH)}...` : element.txAsuntoCorreo}</p>,
            sortable: false,
            minWidth: '250px'
        },
        {
            name: 'Usuario asignado',
            cell: (element) => <p>{element.usuarioActual}</p>,
            selector: row => row.usuarioActual,
            sortable: true,
            minWidth: '180px'
        },
        {
            name: 'Usuario que registró',
            cell: (element) => <p>{element.usuario}</p>,
            selector: row => row.usuario,
            sortable: true,
            minWidth: '180px'
        },
        {
            name: 'Fecha de registro',
            cell: (element) => <p>{moment(element.dtFechaRegistro).format('YYYY-MM-DD HH:mm:ss')}</p>,
            selector: row => row.dtFechaRegistro,
            sortable: true,
            minWidth: '150px'
        },
    ];


    const filterDataTable = (value: string) => {
        const dataArray = dataSource.filter((item: any) => {
            return item.dtFechaOrientacion.toString().substring(0, 10).includes(value) ||
                item.estado?.toLowerCase().includes(value) ||
                item.vcCorreo?.toLowerCase().includes(value) ||
                item.tipoGestion?.toLowerCase().includes(value) ||
                item.tipoProcesoFallido?.toLowerCase().includes(value) ||
                item.vcNombreCompleto?.toLowerCase().includes(value) ||
                item.tipoSolicitud?.toLowerCase().includes(value) ||
                item.motivo?.toLowerCase().includes(value) ||
                item.subMotivo?.toLowerCase().includes(value) ||
                item.txAsuntoCorreo?.toLowerCase().includes(value) ||
                item.usuario?.toLowerCase().includes(value) ||
                item.dtFechaRegistro?.toString().substring(0, 10).includes(value);
        });
        setDataSourceFilter(dataArray);
    }

    return <>
        <bandejaWebContext.Provider value={datosBandejaWebContext}>
            <Container fluid>
                <Card className="mt-5">
                    <Card.Header>
                        <Card.Title className="fw-bold text-azul-oscuro">
                            {modo === '1' ? 'Bandeja de casos propios de atenciones web' : ''}
                            {modo === '2' ? 'Bandeja de seguimiento atenciones web' : ''}
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{ ...payload }}
                            onReset={(values, formProps) => {

                            }}
                            validationSchema={BandejaWebSchema}
                            onSubmit={async (values: any, { setSubmitting }) => {
                                obtenerBandeja({
                                    DtFechaInicio: values.DtFechaInicio,
                                    DtFechaFin: values.DtFechaFin,
                                    EstadoId: values.EstadoId,
                                    VcCorreo: values.VcCorreo,
                                    UsuarioId: values.UsuarioId
                                });
                                setSubmitting(false);
                            }}
                        >
                            {({
                                isSubmitting,
                                setFieldValue,
                                values
                            }) => (
                                <Form>
                                    <div className="form-group row">
                                        <FormikInput
                                            type='date'
                                            labelName='Fecha de inicio'
                                            nameSelect='DtFechaInicio'
                                            className='col-12 col-md-3 mt-5'
                                            required={true}
                                        />
                                        <FormikInput
                                            type='date'
                                            labelName='Fecha de fin'
                                            nameSelect='DtFechaFin'
                                            className='col-12 col-md-3 mt-5'
                                            required={true}
                                        />
                                        <FormikSelect
                                            options={dataEstados}
                                            onChange={(selectedOption: any) => {
                                                setFieldValue("EstadoId", selectedOption.value);
                                            }}
                                            value={values.EstadoId}
                                            labelName='Estado'
                                            nameSelect='EstadoId'
                                            className='col-12 col-md-3 mt-5'
                                            required={true}
                                            placeHolder='Seleccione'
                                        />
                                        <FormikInput
                                            type='email'
                                            labelName='Correo electrónico'
                                            nameSelect='VcCorreo'
                                            className='col-12 col-md-3 mt-5'
                                        />
                                        {modo === '2' ?
                                            <FormikSelect
                                                options={dataUsuarios}
                                                onChange={(selectedOption: any) => {
                                                    setFieldValue("UsuarioId", selectedOption.value);
                                                }}
                                                value={values.UsuarioId}
                                                labelName='Usuario asignado'
                                                nameSelect='UsuarioId'
                                                className='col-12 col-md-6 mt-5'
                                                placeHolder='Seleccione'
                                                required={true}
                                            /> : null
                                        }
                                        <div className="col-12 mt-5">
                                            <CrudButton type={'submit'} className="btn-sm btn-primaryCustom float-end mx-2" text="Buscar" disabled={isSubmitting} />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        {dataSource.length > 0 ?
                            <InputFilter
                                valueFilter={valueFilter}
                                setValueFilter={setValueFilter}
                                onChange={filterDataTable}
                                nameFile="Bandeja Atenciones Web"
                                dataSource={dataSourceFilter}
                            />
                            : null
                        }

                        <Container fluid className="form-group row mt-5">
                            <Col>
                                <DataTable
                                    columns={columns}
                                    data={dataSourceFilter}
                                    pagination
                                    customStyles={customStyles}
                                    paginationComponentOptions={PaginationProperties}
                                    noDataComponent={<NoRecords />}
                                    expandableRows
                                    expandableRowsComponent={CustomExpanderGeneric}
                                />
                            </Col>
                        </Container>
                    </Card.Body>
                </Card>
            </Container>


            <ActionModal visible={modalReAsignar} title={'Asignaciones del caso'} size='xl' handleClose={setModalReAsignar}>
                <AtencionesWebFormReasignar AtencionWebId={AtencionWebId} UsuarioId={userDto.id} UsuarioLogueado={UsuarioLogueado} />
            </ActionModal>
            <ActionModal visible={modalSeguimiento} title={'Registrar seguimiento al caso'} size='lg' handleClose={setModalSeguimiento}>
                <AtencionesWebFormSeguimiento />
            </ActionModal>
            <ActionModal visible={modalOtrosCasos} title={'Otros casos del usuario'} size='xl' fullscreen={true} handleClose={setModalOtrosCasos}>
                <AtencionesWebFormOtrosCasos PersonaWebId={PersonaWebId} AtencionWebId={AtencionWebId} />
            </ActionModal>
            <ActionModal visible={modalAnexos} title={'Anexos del caso'} size='xl' handleClose={setModalAnexos}>
                <AtencionesWebFormAnexos AtencionWebId={AtencionWebId} />
            </ActionModal>

            <ActionModal visible={modalVisiblePdf} title={'Documento PDF del caso'} size={'xl'} fullscreen={true} handleClose={setModalVisiblePdf}>
                <PdfBase64 pdfBase64={dataSourcePdf} />
            </ActionModal>

        </bandejaWebContext.Provider>
    </>
}

